<mat-form-field>
  <mat-label>Scope</mat-label>
  <mat-select disableOptionCentering [formControl]="currentScope" (selectionChange)="onScopeChange($event.value)" multiple>
    <mat-option (click)="toggleAllSelection()" *ngIf="!allSelected()">All</mat-option>
    <mat-option *ngFor="let scope of scopeList" [value]="scope.id">
      {{scope.viewText}}
    </mat-option>
  </mat-select>
</mat-form-field>
